import { useSelector } from 'react-redux';
import { Redux } from '../redux';
import carDetailsDuck from '../redux/carDetails/carDetails.duck';
import { useFeatureSwitchEnabled } from '@hooks/useFeatureSwitchEnabled';
import { FEATURES_LIST } from '../context/featureSwitch';
import { IS_B2B } from '../constants/main';

const getSiteTarget = () => {
    if (IS_B2B) {
        return 'B2B';
    }

    return 'B2C';
};

export const useGetCustomerTypeGtm = () => {
    let customerType = getSiteTarget();
    const currentDeal = useSelector((state: Redux) => carDetailsDuck.getOwnState(state).currentDeal);
    const isPromoCodeCustomerTypeEnabled = useFeatureSwitchEnabled(
        FEATURES_LIST.FEATURE_SWITCH_PROPAGATE_PROMO_CODE_CUSTOMER_TYPE
    );

    if (isPromoCodeCustomerTypeEnabled) {
        if (currentDeal?.extraFields?.promoCode) {
            customerType = JSON.parse(currentDeal?.extraFields?.promoCode)?.customerType;
        }
    }

    return customerType;
};
